module.exports = __webpack_public_path__ + "4917a7900dc3e2c298279c15a1e1f762.png";


//////////////////
// WEBPACK FOOTER
// ./js/components/support/logos/SP3Logo/logo-sp3.png
// module id = 1221
// module chunks = 0